export { default } from './LanguagePicker.js';
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/LanguagePicker/index.js